// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'peekpanel-arrow-right';

export const Component = () => (
  <path d='M18.637 0h3.923c1.084 0 1.962.878 1.962 1.962v20.597a1.962 1.962 0 0 1-1.962 1.962h-3.923a1.962 1.962 0 0 1-1.962-1.962V1.962C16.675.878 17.553 0 18.637 0Zm0 1.962v20.597h3.923V1.962h-3.923ZM6.25 8.58c-.247-.165-.362-.433-.362-.744 0-.59.38-.97.968-.97.26 0 .496.1.68.286l4.927 4.891.092.129c.154.308.196.405.196.555 0 .168-.064.34-.196.603l-.092.129-4.926 4.89a.945.945 0 0 1-.682.287c-.589 0-.968-.38-.968-.97 0-.327.098-.6.347-.743l3.17-3.178H.969c-.6 0-.968-.406-.968-1.018 0-.591.379-.97.968-.97h8.438L6.25 8.578h.001Z' />
);

export const viewBox = '0 0 25 25';
